import React from 'react';
import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const CommissionExplanationModal = ({ isOpen, onClose, constructionType = null }) => {

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="relative z-50"
    >
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      
      <div className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto">
        <Dialog.Panel className="mx-auto max-w-2xl w-full max-h-[90vh] bg-white rounded-lg shadow-xl flex flex-col">
          <div className="flex items-center justify-between p-6 border-b flex-shrink-0">
            <Dialog.Title className="text-lg font-semibold">
              수수료 계산 방식 안내
            </Dialog.Title>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>

          <div className="p-6 space-y-6 overflow-y-auto flex-1">
            <div>
              <h3 className="text-base font-semibold mb-3">수수료 계산 원리</h3>
              <div className="bg-blue-50 p-4 rounded-lg">
                <p className="text-sm text-blue-800 mb-2">
                  수수료는 <strong>구간별 누진제</strong>로 계산됩니다.
                </p>
                <p className="text-sm text-gray-700">
                  각 금액 구간에 해당하는 금액만큼 해당 구간의 수수료율이 적용되어 합산됩니다.
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-base font-semibold mb-3">계산 예시</h3>
              <div className="bg-gray-50 p-4 rounded-lg space-y-4">
                <div>
                  <p className="text-sm font-medium mb-2">인테리어 공사 7,000만원의 경우:</p>
                  <div className="space-y-1 text-sm text-gray-700">
                    <p>• 0 ~ 5,000만원 구간: 5,000만원 × 15% = 750만원</p>
                    <p>• 5,000만원 ~ 7,000만원 구간: 2,000만원 × 12% = 240만원</p>
                    <p className="font-medium text-blue-600 pt-2">
                      → 총 수수료: 750만원 + 240만원 = 990만원
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-base font-semibold mb-3">중요 안내사항</h3>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  <span>수수료는 프로젝트가 <strong>계약 단계</strong>로 변경될 때 자동 계산됩니다.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  <span>계산된 수수료는 입금 신청 후 관리자 확인을 거쳐 정산됩니다.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  <span>소장별로 개별 수수료율이 설정된 경우 해당 요율이 우선 적용됩니다.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-blue-500 mr-2">•</span>
                  <span>복수 공사 유형인 경우 각 유형별로 계약금액을 균등 분할하여 계산합니다.</span>
                </li>
              </ul>
            </div>

            {constructionType && (
              <div>
                <h3 className="text-base font-semibold mb-3">{constructionType} 수수료율</h3>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-600">
                    해당 공사 유형의 구체적인 수수료율은 상단 표에서 확인하실 수 있습니다.
                  </p>
                </div>
              </div>
            )}
          </div>

          <div className="bg-gray-50 px-6 py-4 flex justify-end flex-shrink-0 border-t">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
            >
              확인
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default CommissionExplanationModal;